import React, { useState } from 'react';
import { ButtonBase, makeStyles, Typography } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { ArrowLeftIcon } from '../../../../components/Icon';
import { i18n } from '../../../../language';
import { classNames, useGetUserInfo } from '../../../../utils';
import { WARD_INFO } from '../../../../comm/constant';
import { LoginPop } from '../../../../components/Login';
import { useActionableTicketReminder } from '../../../../utils/hooks';
import SettingRemarks from './SettingRemarks';
import SettingTransferIn from './SettingTransferIn';
const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: 'NotoSans-Medium',
    height: 'calc(100vh - 4.375rem)',
    overflowY: 'auto',
  },
  toolbar: {
    margin: '3rem 3.437rem 1.688rem',
    display: 'flex',
    alignItems: 'center',
    color: '#538fff',
  },
  arrowLeftIcon: {
    fontSize: '1rem',
  },
  back: {
    paddingLeft: '1rem',
    fontSize: '0.875rem',
    fontWeight: '500',
    lineHeight: '1.43',
  },
  tabButton: {
    width: '10rem',
    height: '3.875rem',
    borderRadius: '0.625rem 0.625rem 0 0',
    fontSize: '1rem',
    fontWeight: 'bold',
    background: '#538fff11',
    color: '#538fff88',
  },
  selectTabBtn: {
    background: '#fff',
    color: '#538fff',
  },
  bedStatusSetting: {
    fontSize: '1.875rem',
    fontWeight: 'bold',
    lineHeight: '1',
    color: '#2e4469',
  },
  addOptionBtn: {
    width: '10rem',
    height: '3rem',
    background: '#538fff',
    color: '#fff',
    borderRadius: '0.625rem',
  },
  addIcon: {
    fontSize: '1rem',
    paddingRight: '0.313rem',
  },
  addOption: {
    fontSize: '1rem',
    fontWeight: '500',
  },
  table: {
    position: 'relative',
    minWidth: '65rem',
    '& .MuiTableCell-root': {
      border: 'none',
      fontSize: '1.125rem',
      fontWeight: '500',
      lineHeight: '1.675rem',
      color: '#2e4469',
      padding: '0 1rem ',
    },
    '& .MuiTableHead-root': {
      position: 'sticky',
      top: '0',
      left: '0',
      zIndex: '10',
      '& .MuiTableRow-root': {
        backgroundColor: '#fff',
      },
      '& .MuiTableCell-root': {
        fontWeight: 'bold',
        color: '#538fff',
        padding: '1rem',
        backgroundColor: '#fff',
        fontSize: '0.875rem',
      },
    },
    '& .MuiTableBody-root': {
      '& :hover': {
        backgroundColor: '#f5faff',
      },
      '& > .MuiTableRow-root': {
        borderBottom: '1px solid #E6E8E9',
      },
      '& .MuiTableCell-root': {
        height: '3.5rem',
        fontFamily: 'NotoSans-Medium',
      },
      '& .MuiTableCell-root:nth-child(1)': {
        borderRadius: '0.937rem 0 0 0',
      },
      '& .MuiTableCell-root:nth-last-child(1)': {
        borderRadius: '0 0.937rem 0 0',
      },
    },
  },
  status: {
    width: '0.625rem',
    height: '0.625rem',
    display: 'inline-block',
    backgroundColor: '#28d2ab',
    borderRadius: '50%',
    marginRight: '0.563rem',
  },
  editBtn: {
    width: '2.25rem',
    height: '2.25rem',
    minWidth: '0',
    boxShadow: '0 10px 20px 0 rgba(76, 147, 255, 0.4)',
    backgroundColor: '#4c93ff',
    borderRadius: '0.625rem',
    color: '#fff',
    '&:hover': {
      background: '#4c93ff !important',
    },
  },
  editIcon: {
    fontSize: '1rem',
    '&:hover': {
      background: '#4c93ff !important',
    },
  },
  tableHead: {
    whiteSpace: 'nowrap',
  },
}));

const Setting = ({ history, loginInfo, rouList }) => {
  const language = useSelector((state) => state.settings.language);
  const [dom, setDom] = useState(HTMLDivElement | null);
  const [bottomFlag, setBottomFlag] = useState(false);
  const userInfo = useGetUserInfo();
  const classes = useStyles();
  const size = 20;
  useActionableTicketReminder('audio', 'BS');

  const backHandle = () => {
    history.goBack(1);
  };

  const infoJSON = JSON.parse(localStorage.getItem(WARD_INFO));

  const handleDoubleClick = (diagnosis, isActive, row, show) => {
    show(diagnosis, isActive, row)();
  };

  function hasScrollbar() {
    return dom?.scrollHeight > (window.innerHeight || document.documentElement.clientHeight);
  }

  const handleOnScroll = () => {
    if (dom) {
      const contentScrollTop = dom.scrollTop;
      const clientHeight = dom.clientHeight;
      const scrollHeight = dom.scrollHeight;
      if (contentScrollTop + clientHeight >= scrollHeight) {
        setBottomFlag(true);
      }
    }
  };
  const [tabIndex, setTabIndex] = useState(
    sessionStorage.getItem('bsSettingType') ? parseInt(sessionStorage.getItem('bsSettingType')) : 0
  );
  const container = [
    { id: 0, title: i18n.t('BEDSTATUS_REMARKS'), component: SettingRemarks, idName: 'bed_setting_tab1' },
    { id: 1, title: i18n.t('BEDSTATUS_TRANSFER_IN'), component: SettingTransferIn, idName: 'bed_setting_tab2' },
  ];
  const tabHnadler = (data, index) => {
    return () => {
      setTabIndex(index);
      sessionStorage.setItem('bsSettingType', index);
    };
  };
  const showContainer = () => {
    let index = container.findIndex((item, index) => {
      return index === tabIndex;
    });
    let Component = index > -1 ? container[index].component : null;
    Component = Component ?? container[0].component;
    return (
      <Component
        infoJSON={infoJSON}
        rouList={rouList}
        userInfo={userInfo}
        bottomFlag={bottomFlag}
        size={size}
        setBottomFlag={setBottomFlag}
        handleDoubleClick={handleDoubleClick}
        hasScrollbar={hasScrollbar}
        language={language}
        tabHandler={(index) => {
          tabHnadler(null, index)();
        }}
      />
    );
  };

  return loginInfo.flag ? (
    <div className={classes.root} ref={(props) => setDom(props)} onScroll={() => handleOnScroll()}>
      <div className={classes.toolbar}>
        <ButtonBase onClick={backHandle}>
          <ArrowLeftIcon className={classes.arrowLeftIcon} />
          <Typography className={classes.back}>{i18n.t('BEDSTATUS_BACK')}</Typography>
        </ButtonBase>
      </div>
      <div style={{ margin: '0 3.437rem' }}>
        {container.map((item, index) => {
          return (
            <ButtonBase
              key={item.id}
              id={item.idName}
              className={(() => {
                return index === tabIndex ? classNames(classes.tabButton, classes.selectTabBtn) : classes.tabButton;
              })()}
              onClick={tabHnadler(item, index)}
              style={{ marginRight: '1rem' }}
            >
              {item.title}
            </ButtonBase>
          );
        })}
      </div>
      {/* <SettingRemarks
        infoJSON={infoJSON}
        rouList={rouList}
        userInfo={userInfo}
        bottomFlag={bottomFlag}
        size={size}
        setBottomFlag={setBottomFlag}
        handleDoubleClick={handleDoubleClick}
        hasScrollbar={hasScrollbar}
      /> */}
      {showContainer()}
    </div>
  ) : (
    <LoginPop closehandle={backHandle} />
  );
};

export default connect((state) => ({
  loginInfo: state.loginInfo,
  rouList: state.rouList,
}))(withRouter(Setting));
